import { useQuery } from '@tanstack/react-query'
import { fetchPaymentMethods } from '../subscriptions'
import { paymentMethodsQueryKey } from './stripeBillingQueryKeys'

interface UsePaymentMethodsProps {
  slug: string
  enabled?: boolean
}

export const paymentMethodsQueryOptions = ({ slug, enabled = true }: UsePaymentMethodsProps) => ({
  queryKey: paymentMethodsQueryKey(slug),
  queryFn: () => fetchPaymentMethods({ slug }),
  enabled: Boolean(slug) && enabled
})

export const usePaymentMethods = ({ slug, enabled = true }: UsePaymentMethodsProps) =>
  useQuery(paymentMethodsQueryOptions({ slug, enabled }))

export { paymentMethodsQueryKey } from './stripeBillingQueryKeys'
